import InternalAvatar from './Avatar';
import AvatarGroup from './AvatarGroup';
const Avatar = InternalAvatar;
Avatar.Group = AvatarGroup;
export default Avatar;
